<template>
  <!-- 学生出入统计模块边框  -->
  <div class="h-border-box-1" :style="{background:background}">
    <img class="h-border-box-1-bg1 h-border-box-1-bg1-position1" src="static/img/student/border-box-1-bg1.png" alt="">
    <img class="h-border-box-1-bg1 h-border-box-1-bg1-position2" src="static/img/student/border-box-1-bg1.png" alt="">
    <img class="h-border-box-1-bg1 h-border-box-1-bg1-position3" src="static/img/student/border-box-1-bg1.png" alt="">
    <img class="h-border-box-1-bg1 h-border-box-1-bg1-position4" src="static/img/student/border-box-1-bg1.png" alt="">
    <div class="h-border-box-1-title" v-if="title">
      <div class="head" v-if="head">{{head}}</div>
      <span class="h-border-box-1-title-text" :style="{'margin-left': head ? '15px' : '30px'}">{{title}}</span>
      <img class="h-border-box-1-title-icon" src="static/img/student/border-box-1-bg2.png" alt="">
      <div class="h-border-box-1-title-border"></div>
      <div class="h-border-box-1-title-border2"></div>
    </div>
    <div class="h-border-box-1-content">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  props: {
    background: {
      //背景颜色
      type: String,
      default: 'rgba(5, 80, 123, 0.2)',
    },
    title: {
      type: String,
      default: '',
    },
    head: {
      type: String,
      default: '',
    },
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  methods: {},
}
</script>
<style scoped lang="stylus">
.h-border-box-1
  height 100%
  width 100%
  position relative
  display flex
  flex-direction column
  .h-border-box-1-bg1
    height 20px
    width 20px
    position absolute
  .h-border-box-1-bg1-position1
    top 0
    left 0
  .h-border-box-1-bg1-position2
    top 0
    right 0
    transform rotate(90deg)
  .h-border-box-1-bg1-position3
    bottom 0
    right 0
    transform rotate(180deg)
  .h-border-box-1-bg1-position4
    bottom 0
    left 0
    transform rotate(270deg)
  .h-border-box-1-title
    position relative
    display flex
    flex-direction row
    align-items center
    height 57px
    width 100%
    flex-shrink 0
    .h-border-box-1-title-text
      flex 1
      height 20px
      line-height 20px
      font-size 20px
      color #52FBFF
      font-weight 400
      margin-left 15px
      font-family Source Han Sans CN
    .h-border-box-1-title-icon
      margin-right 23px
    .h-border-box-1-title-border
      position absolute
      bottom 0
      height 1px
      width 100%
      background-color rgba(5, 80, 123, 1)
    .h-border-box-1-title-border2
      position absolute
      bottom 0
      left 30px
      height 1px
      width 32px
      background-color #1BCAF2
  .h-border-box-1-content
    flex 1
    width 100%
    overflow hidden
.head
  width 76px
  height 40px
  display flex
  align-items center
  justify-content center
  background-color #05507b
  border 1px solid #1B6883
  color #95F9FB
  font-size 24px
  margin-left 30px
</style>



// WEBPACK FOOTER //
// src/components/parts/h-border-box/h-border-box-3.vue